var map = {
	"./Logo.svg": 932,
	"./LogoBlack.svg": 786,
	"./VS.svg": 715,
	"./X-icon.svg": 911,
	"./arrowIcon.svg": 512,
	"./document.svg": 751,
	"./slide1.svg": 167,
	"./김경재.svg": 418,
	"./김민찬.svg": 413,
	"./김재연.svg": 749,
	"./심상정.svg": 475,
	"./안철수.svg": 203,
	"./오준호.svg": 351,
	"./옥은호.svg": 118,
	"./윤석열.svg": 890,
	"./이경희.svg": 495,
	"./이백윤.svg": 638,
	"./이재명.svg": 873,
	"./조원진.svg": 231,
	"./허경영.svg": 593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;